export const TOKEN_KEY = 'access_token';
export const BALANCE_KEY = 'balance_user';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const ROLE_KEY = 'roles';
export const BROADCAST_CHANNEL_KEY = 'BROADCAST_CHANNEL_KEY';

export const PAGE_URL = {
  HOME: '/',
  ABOUT: '/about',
  PRODUCT: '/product',
  NEWS: '/news',
  CONTACT: '/contact',
};

export const VALIDATE_FORM = {
  MAX_LENGTH_INPUT: 256,
  MAX_LENGTH_TEXTAREA: 2048,
  MAX_LENGTH_PASSWORD: 20,
};

export const REGEX_APP = {
  REGEX_PHONE_NUMBER: /^0\d{9,11}$/,
  REGEX_EMAIL: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/,
  REGEX_NOT_CONTAIN_ALL_SPACES: /^.*\S.*$/,
  REGEX_INTEGER: /^[1-9]\d*$/,
};

export const PRODUCT_LIST = {
  Fyndr: 'Fyndr',
  Lynkr: 'Lynkr',
  Driftor: 'Driftor',
  SeekrCore: 'Seekr Core',
  SimpOSM: 'SimpOSM',
  FadrBase: 'FadrBase',
  Vulnscan: 'Vulnscan',
};

export const PRODUCT_LIST_URL = {
  Fyndr: 'fyndr',
  Lynkr: 'lynkr',
  Driftor: 'driftor',
  SeekrCore: 'seekrcore',
  SimpOSM: 'simposm',
  FadrBase: 'fadrbase',
  Vulnscan: 'vulnscan',
};
